export const SET_SETTINGS_EMPRESA = "SET_SETTINGS_EMPRESA";

export const setSettingsEmpresa = (settings) => ({
    type: SET_SETTINGS_EMPRESA,
    payload: settings,
});
